import {call, put, takeLatest} from 'redux-saga/effects';
import ApiUtil from "src/utils/ApiUtil";
import {
    getNewProgramFeesQueryFailedAction, getNewProgramFeesQuerySuccessAction,
    NEW_PROGRAM_FEES_QUERY_START,
    ADDITIONAL_NEW_PROGRAM_FEES_QUERY_START,
    UPDATE_NEW_PROGRAM_FEES_QUERY_START,
    NewProgramFeesQueryStartAction
} from "src/actions/NewProgramFeesQueryAction";


export function* getNewProgramFees(action: NewProgramFeesQueryStartAction) {
    try {
        let parameters;
        if (action.programParamMap != undefined) {
            parameters = {
                countryCode: action.countryCode,
                itemInfo: action.queryProduct,
                programIdList: action.programIdList,
                programParamMap: action.programParamMap
            }
        } else {
            parameters = {
                countryCode: action.countryCode,
                itemInfo: action.queryProduct,
                programIdList: action.programIdList,
            };
        }
        // @ts-ignore
        const response = yield call(ApiUtil.postApiWithTimeout, "getfeeswithnew", parameters);
        if (response.succeed) {
            yield put(getNewProgramFeesQuerySuccessAction(action.programIdList, response.data));
        } else {
            yield put(getNewProgramFeesQueryFailedAction(action.programIdList));
        }
    } catch (error) {
        console.error("Call API getfeeswithnew error" + error)
        yield put(getNewProgramFeesQueryFailedAction(action.programIdList));
        return;
    }
}

export default function* newProgramFees() {
    yield takeLatest([NEW_PROGRAM_FEES_QUERY_START, ADDITIONAL_NEW_PROGRAM_FEES_QUERY_START, UPDATE_NEW_PROGRAM_FEES_QUERY_START], getNewProgramFees);
}